import axios from 'axios';
import moment from 'moment-timezone';

const isPar = (number) => {
  if (number % 2 === 0) {
    return true;
  } else {
    return false;
  }
}


const isValidMonth = (month,event) => {
  let startDay = moment(`${month.startDate} 00:00:00`);
  let endDay = moment(`${month.endDate} 23:59:59`);
  let dateStart = moment(event.start);
  if(dateStart.isSameOrAfter(startDay) && dateStart.isSameOrBefore(endDay)) {
    return true;
  }
  return false;
}

const isValidYear = (year,event) => {
  let startDay = moment(`${year.January.startDate} 00:00:00`);
  let endDay = moment(`${year.December.endDate} 23:59:59`);
  let dateStart = moment(event.start);
  if(dateStart.isSameOrAfter(startDay) && dateStart.isSameOrBefore(endDay)) {
    return true;
  }
  return false;
}

const state = () => ({
  events: [],
  registrations: [],
  calendar: {},
  refreshCalendar: false
});

const getters = {
  GET_EVENTS: (state) => state.events,
  GET_REGISTRATIONS: (state) => state.registrations,
  GET_CALENDAR: (state) => state.calendar,
  GET_REFRESH_CALENDAR: (state) => state.refreshCalendar
}

const mutations = {
  SET_EVENTS: (state, events) => {
    state.events = events
  },
  SET_REGISTRATIONS: (state, registrations) => {
    state.registrations = registrations
  },
  SET_CALENDAR: (state, calendar) => {
    const { year, structureYear } = calendar;
    state.calendar[year] = structureYear;
  },
  SET_CALENDAR_G: (state, calendar) => {
    state.calendar = calendar;
  },
  SET_REFRESH_CALENDAR: (state, refreshCalendar) => {
    state.refreshCalendar = refreshCalendar
  }
}

const actions = {
  async GET_CALENDAR_OPTION({ commit, rootGetters }, promoter) {
    let today = new Date()
    let cYear = today.getFullYear() - 2
    let cMonth = today.getMonth()
    let cDate = today.getDate()
    today = cYear + '-' + cMonth + '-' + cDate;

    try {
      // Asegúrate de que rootGetters está disponible aquí
      if (rootGetters && rootGetters['VUE_APP_DEV_API_HOST']) {
        const eventsResponse = await axios.post(
          `${rootGetters['VUE_APP_DEV_API_HOST']}/laravel/public/api/v1/livelaps/event/getEventsForCalendar?date=${today}&type=event&promoterId=${promoter ? '&promoterId=' + promoter : ''}`
        )
        const registrationsResponse = await axios.post(
          `${rootGetters['VUE_APP_DEV_API_HOST']}/laravel/public/api/v1/livelaps/event/getEventsForCalendar?date=${today}&type=regis&promoterId=${promoter ? '&promoterId=' + promoter : ''}`
        )
        commit('SET_EVENTS', eventsResponse.data.message)
        commit('SET_REGISTRATIONS', registrationsResponse.data.message)
      } else {
        //console.error('rootGetters or rootGetters[\'env/GET_DOMAIN\'] is undefined.');
      }
    } catch (e) {
      //console.error(e);
    }

    try {
      const eventsResponse = await axios.post(
        `${rootGetters['VUE_APP_DEV_API_HOST']}/laravel/public/api/v1/livelaps/event/getEventsForCalendar?date=${today}&type=event&promoterId=${promoter ? '&promoterId=' + promoter : ''}`
      )
      const registrationsResponse = await axios.post(
        `${rootGetters['VUE_APP_DEV_API_HOST']}/laravel/public/api/v1/livelaps/event/getEventsForCalendar?date=${today}&type=regis&promoterId=${promoter ? '&promoterId=' + promoter : ''}`
      )
      commit('SET_EVENTS', eventsResponse.data.message)
      commit('SET_REGISTRATIONS', registrationsResponse.data.message)
    } catch (e) {
      //console.log(e)
    }
  },
  async GET_CALENDAR_STRUCTURE({ commit }, year) {
      const startDate = moment(year, 'YYYY').startOf('year');
      const endDate = moment(year, 'YYYY').endOf('year');
      let firstSunday = startDate.clone().endOf('isoWeek').set({ hour: 0, minute: 0, second: 0, millisecond: 999 });
      let structureYear = {};
      let aux = firstSunday.clone().add(6, 'days').set({ hour: 23, minute: 59, second: 59, millisecond: 999 });
      let month = firstSunday.format('MMMM');
      let monthAb = firstSunday.format('MMM');
      let monthNumber = firstSunday.format('MM');
      let day = firstSunday.format('D');
      structureYear[month] = {
          weeks: [],
          title: `${month} ${year}`
      };
      let monthEnd = aux.format('MM');
      let monthEndTextAb = aux.format('MMM');
      //let monthEndText = aux.format('MMMM');
      let dayEnd = aux.format('D');
      let range = '';
      if(monthNumber == monthEnd) {
          range = `${monthAb} ${day} - ${dayEnd}`;
      } else {
          range = `${monthAb} ${day} - ${monthEndTextAb} ${dayEnd}`;
      }
      structureYear[month].weeks.push({
          start: firstSunday.format('YYYY-MM-DD'),
          //startObject: firstSunday,
          end: aux.format('YYYY-MM-DD'),
          //endObject: aux,
          rangeText: range, 
          bandReverse: false,
          cont: null,
          events: []
      });
      firstSunday = aux;
      
      let currentDate = firstSunday.clone().add(1, 'days').set({ hour: 0, minute: 0, second: 0, millisecond: 0 });

      while (currentDate.isSameOrBefore(endDate)) {
          let endWeek = currentDate.clone().add(6, 'days').set({ hour: 23, minute: 59, second: 59, millisecond: 999 });
          month = currentDate.format('MMMM');
          monthAb = currentDate.format('MMM');
          monthNumber = currentDate.format('MM');
          day = currentDate.format('D');
          if(!structureYear[month]) {
              structureYear[month] = {
                  weeks: [],
                  title: `${month} ${year}`
              };
          }
          monthEnd = endWeek.format('MM');
          //monthEndText = endWeek.format('MMMM');
          monthEndTextAb = endWeek.format('MMM');
          dayEnd = endWeek.format('D');
          if(monthNumber == monthEnd) {
              range = `${monthAb} ${day} - ${dayEnd}`;
          } else {
              range = `${monthAb} ${day} - ${monthEndTextAb} ${dayEnd}`;
          }
          structureYear[month].weeks.push({
              start: currentDate.format('YYYY-MM-DD'),
              //startObject: currentDate,
              end: endWeek.format('YYYY-MM-DD'),
              //endObject: endWeek,
              rangeText: range,
              bandReverse: false, 
              cont: null,
              events: []
          });
          currentDate = endWeek.clone().add(1, 'days').set({ hour: 0, minute: 0, second: 0, millisecond: 0 });
      }
      commit('SET_CALENDAR', { structureYear, year });
      commit('SET_REFRESH_CALENDAR', true);
  },
  SET_REFRESH_CALENDAR({ commit }, refresh) {
    commit('SET_REFRESH_CALENDAR', refresh);
  },
  GET_SETTING_CALENDAR({ commit, getters }, events) {
    let calendar = JSON.parse(JSON.stringify(getters['GET_CALENDAR']));
    for (let year in calendar) {
      for (let month in calendar[year]) {
        calendar[year][month].startDate = calendar[year][month].weeks[0].start;
        calendar[year][month].endDate = calendar[year][month].weeks[calendar[year][month].weeks.length - 1].end;
        for (let i = 0; i < calendar[year][month].weeks.length; i++) {
          calendar[year][month].weeks[i].events = [];
        }
      }
    }

    events.forEach((event) => {
      let dateStart = moment(event.start);
      //let year = dateStart.format('YYYY');
      for(let year in calendar) {
        if(isValidYear(calendar[year],event)) {
          for(let month in calendar[year])  {
            if(calendar[year] && isValidMonth(calendar[year][month],event)) {
                calendar[year][month].weeks.forEach((week,i) => {
                    let startDay = moment(`${week.start} 00:00:00`);
                    let endDay = moment(`${week.end} 23:59:59`);
                    if(dateStart.isSameOrAfter(startDay) && dateStart.isSameOrBefore(endDay)) {
                        let bandIndex = false;
                        let index = -1;
                        week.events.forEach((_event, k) => {
                            let reviewEvent = moment(_event.start);
                            if(!bandIndex && reviewEvent.isAfter(dateStart)) {
                                index = k;
                                bandIndex = true;
                            }
                        });
                        if(bandIndex) {
                            calendar[year][month].weeks[i].events.splice(index,0,{
                                ...event,
                                title: `${dateStart.format('ddd')} ${dateStart.format('D')}`,  
                                subtitle: '',
                                bandReverse: false,
                                cont: 0
                            });
                        } else {
                            calendar[year][month].weeks[i].events.push({
                                ...event,
                                title: `${dateStart.format('ddd')} ${dateStart.format('D')}`,  
                                subtitle: '',
                                bandReverse: false,
                                cont: 0
                            });
                        }
                    }
                });
            }
          }
      
        }
      }
    });

    for (let year in calendar) {
      for (let month in calendar[year]) {
        let band = false;
        for (let i = 0; i < calendar[year][month].weeks.length; i++) {
          if (calendar[year][month].weeks[i].events.length > 0) {
            band = true;
            break;
          }
        }
        calendar[year][month].visible = band;
      }
    }

    for (let year in calendar) {
      for (let month in calendar[year]) {
        let cont = 1;
        let band = false;
        calendar[year][month].weeks.forEach((week, i) => {
          calendar[year][month].weeks[i].cont = cont;
          calendar[year][month].weeks[i].bandReverse = isPar(cont);
          cont++;
          week.events.forEach((event, j) => {
            calendar[year][month].weeks[i].events[j].cont = cont;
            calendar[year][month].weeks[i].events[j].bandReverse = isPar(cont);
            cont++;
          });
          if (calendar[year][month].weeks[i].events.length > 0) {
            band = true;
          }
        });
        calendar[year][month].visible = band;
      }
    }
    commit('SET_CALENDAR_G', calendar);
  }
}

export default {
  state, mutations, actions, getters
}

